import { render, staticRenderFns } from "./MessageEs.vue?vue&type=template&id=b40e923e&scoped=true"
import script from "./MessageEs.vue?vue&type=script&lang=js"
export * from "./MessageEs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e923e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40e923e')) {
      api.createRecord('b40e923e', component.options)
    } else {
      api.reload('b40e923e', component.options)
    }
    module.hot.accept("./MessageEs.vue?vue&type=template&id=b40e923e&scoped=true", function () {
      api.rerender('b40e923e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Final/MessageEs.vue"
export default component.exports